<h4 class="profile-form" style="margin-bottom: 0px;">New Payment Method</h4>
<form novalidate>
  <app-payment [buttonText]="'Confirm'" [token]="token" (returnToken)=SaveToken($event);></app-payment>
  <br>
  <div class="form-row profile-form" style="margin-top:0px;">
    <button [disabled]="!token" type="button" class="btn btn-primary btn-block" (click)="AddNewPaymentMethod()">Add New
      Payment Method</button>
    <button *ngIf="!forceUpdate" type="button" class="btn btn-secondary btn-block " (click)="Back_OnClick()">Back</button>
  </div>
</form>